import { render, staticRenderFns } from "./DieCastingAutomation.vue?vue&type=template&id=a0422e88&scoped=true&"
import script from "./DieCastingAutomation.vue?vue&type=script&lang=js&"
export * from "./DieCastingAutomation.vue?vue&type=script&lang=js&"
import style0 from "./DieCastingAutomation.vue?vue&type=style&index=0&id=a0422e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0422e88",
  null
  
)

export default component.exports